import { render, staticRenderFns } from "./TheConsentToggle.vue?vue&type=template&id=16a9a14e&scoped=true"
import script from "./TheConsentToggle.vue?vue&type=script&lang=js"
export * from "./TheConsentToggle.vue?vue&type=script&lang=js"
import style0 from "./TheConsentToggle.vue?vue&type=style&index=0&id=16a9a14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a9a14e",
  null
  
)

export default component.exports